/**
 * Django's CSRF token, read from the cookie it sets.
 *
 * Both clients need it: the generated one in `client.ts` for our Ninja routes, and the
 * hand-written one in `auth.ts` for allauth's. Django only sets the cookie on a response from a
 * view that asked for it, so something must prime it before the first POST — see
 * `ensureCsrfCookie`.
 */

const COOKIE = "csrftoken";
const HEADER = "X-CSRFToken";

export function csrfToken(): string | undefined {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE}=`))
    ?.split("=")[1];
}

export function needsCsrf(method: string): boolean {
  return !["GET", "HEAD", "OPTIONS", "TRACE"].includes(method.toUpperCase());
}

export function csrfHeaders(method: string): Record<string, string> {
  const token = needsCsrf(method) ? csrfToken() : undefined;
  return token ? { [HEADER]: token } : {};
}

export { HEADER as CSRF_HEADER };
